// const CHAT_API_BASE_URL = 'http://62.171.153.83:8080/carib-bargains-api-new/ws';
// const CHAT_API_BASE_URL = "http://localhost:8080/ws";
const CHAT_API_BASE_URL = "https://api.caribbargains.com/carib-bargains-testing-app/ws";

export { CHAT_API_BASE_URL };
